import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "edu-video-area" }
const _hoisted_2 = { class: "video-area" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "video-content videoBg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-play" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "popup-video"
}
const _hoisted_8 = { class: "d-table" }
const _hoisted_9 = { class: "d-table-cell" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "play-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/PWvPbGWVRrU",
    allowfullscreen: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrustedByBrands = _resolveComponent("TrustedByBrands")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "video-btn popup-youtube",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args))),
              style: {"cursor":"pointer"}
            }, _hoisted_6)
          ])
        ])
      ]),
      _createVNode(_component_TrustedByBrands)
    ]),
    (_ctx.isPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "popup-overlay-close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args)))
              }, _hoisted_12),
              _hoisted_13
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}